"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyGroupsMessage = void 0;
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../../utils");
var context_1 = require("../../../context");
var useEmptyGroupsMessageStyles = styles_1.makeStyles(function (theme) {
    return {
        root: {
            whiteSpace: 'pre-wrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            fontSize: '16px',
        },
    };
});
exports.EmptyGroupsMessage = function () {
    var isEditSheet = react_1.useContext(context_1.ApprovalSheetManagementContext).isEditSheet;
    var classes = useEmptyGroupsMessageStyles();
    return (react_1.default.createElement(core_1.Box, { p: 3, className: classes.root },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: isEditSheet ? 'emptyGroupsEditText' : 'emptyGroupsText', values: {
                p: utils_1.renderParagraph,
            } })));
};
